import type { ReactNode } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '../lib/utils'

const infoBoxVariants = cva('rounded-lg px-4 py-3 text-sm leading-relaxed', {
  variants: {
    tone: {
      info: 'bg-[var(--color-info-bg)] text-[var(--color-info)]',
      warning: 'bg-[var(--color-warning-bg)] text-[var(--color-warning)]',
      danger: 'bg-[var(--color-danger-bg)] text-[var(--color-danger)]',
      success: 'bg-[var(--color-success-bg)] text-[var(--color-success)]',
    },
  },
  defaultVariants: { tone: 'info' },
})

interface Props extends VariantProps<typeof infoBoxVariants> {
  title?: string
  className?: string
  children: ReactNode
}

/**
 * 정적 안내 박스. 판정·자동 감지 결과를 띄우는 용도로 쓰지 말 것 —
 * BASIC 은 자동 감지를 하지 않으므로 여기 들어갈 내용은 항상 고정 문구다.
 */
export function InfoBox({ tone, title, className, children }: Props) {
  return (
    <div className={cn(infoBoxVariants({ tone }), className)}>
      {title && <p className="mb-1 font-bold">{title}</p>}
      <div className="opacity-90">{children}</div>
    </div>
  )
}
